module.exports = __webpack_public_path__ + "images/emoji/chart_with_downwards_trend.07993ff5a27ceea3adf4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/chart_with_downwards_trend.png
// module id = yU/s
// module chunks = 24